<template>
    <div class="item">
        <div class="title_s">{{ title }}</div>
        <div class="form_s">
            <select class="input_xs" v-model="selectedHour" :disabled="disabled" @change="updateValue">
                <option v-for="t in hours" :key="t" :value="t">{{ t }}</option>
            </select>
            <span>:</span>
            <select class="input_xs" v-model="selectedMin" :disabled="disabled" @change="updateValue">
                <option v-for="t in mins" :key="t" :value="t">{{ t }}</option>
            </select>
        </div>
    </div>
</template>

<script>
import TimePickerForReservation from '@/v2/views/Main/ShareComponents/Common/TimePickerForReservation.vue'
export default {
    mixins: [TimePickerForReservation],
    props: {
        title: String
    }
}
</script>
